export const setURL = (path, params = {}, allPath = false) => {
  let url = allPath ? path : `/kbro_api/api/v1${path}`
  // 替換多變數參數
  const paramsKeys = Object.keys(params)
  if (paramsKeys.length > 0) {
    for (let i = 0; i < paramsKeys.length; i++) {
      const paramsKey = paramsKeys[i]
      url = url.replace(`:${paramsKey}`, params[paramsKey])
    }
  }
  return url
}
